import { Space, theme } from 'antd';
import { useRouter } from 'next/router';
import TicketRelation from '../../../../../../components/TicketInfoLeftSideTabs/TicketRelation';
import useTicketByKey from '../../../../../../hooks/ticketDetailPage/useTicketByKey';

export default function TicketRelationContainer() {
    const {
        token: { paddingXS }
    } = theme.useToken();

    const {
        query: { ticketKey }
    } = useRouter();

    const { data: ticketDetail } = useTicketByKey(ticketKey?.toString());

    if (!ticketDetail) return null;

    return (
        <Space size="small" style={{ paddingTop: paddingXS, marginBottom: -paddingXS }} wrap>
            {ticketDetail.relation.map((relation) => (
                <TicketRelation key={relation.type} ticketRelation={relation} />
            ))}
        </Space>
    );
}
